export default __webpack_public_path__ + "static/Theecologistwhotookontheworld-91133b630b0be651e9238fc6a0e3e596.jpg";